import filterImageUrls from './filterImageUrls';
import { JobQuery } from './graphql/api/graphql';

const transformJob = (job: NonNullable<JobQuery['job']>) => {
  const {
    company,
    teaser,
    applyForm,
    template,
  } = job;
  const { logoUrls } = company;
  const filteredLogoUrls = filterImageUrls(logoUrls);

  return {
    ...job,
    company: {
      ...company,
      logoUrl: filteredLogoUrls,
    },
    qualifications: teaser,
    universalForm: applyForm,
    template: template.id,
  };
};

export default transformJob;
